/**
 * @module geo/actions/creators
 *
 */
import {promiseActionCreator} from '../../helpers/observable.to.promise';
import {SERVICE_GET_IMAGE_MAP} from '../../payload/facade/services/SERVICE_GET_IMAGE_MAP';
import {GetImage} from '../../types/services/get.image';
import {actionCreator} from '../helpers/actions.creator.builder';
import {ActionCreator} from '../helpers/fsa';
import {TypeKeyActions} from '../types.key.action';
import { SERVICE_EXCEPTION } from '../../payload/proxy/SERVICE_EXCEPTION';

/**
 * return an action builder to launch a print map image service
 * @since v 2.1
 */
export const serviceGetImageMapCreator =
    actionCreator<SERVICE_GET_IMAGE_MAP>(TypeKeyActions.SERVICE_GET) as
    ActionCreator<SERVICE_GET_IMAGE_MAP>;
/**
 * action type of serviceGetImageAsyncCreator
 * @since v 2.1
 */
export const serviceGetImageMapAsyncCreator =
    actionCreator.async<SERVICE_GET_IMAGE_MAP, GetImage, SERVICE_EXCEPTION>(
        TypeKeyActions.SERVICE_GET_IMAGE_MAP);
/**
 * return an action builder with a promise to launch a print map image service
 * @since v 2.1
 */
export const serviceGetImageMapAsyncCreatorP =
    promiseActionCreator(serviceGetImageMapCreator, [
        serviceGetImageMapAsyncCreator.done.type,
        serviceGetImageMapAsyncCreator.failed.type,
        serviceGetImageMapAsyncCreator.started.type
    ]);
